import React from "react";
import Button from "../../components/Button/Button";
import Dropdown from "../../components/Countdown/Countdown";
import { strings } from "../../strings";
import styles from "./CountdownSection.module.scss";

export default function CountdownSection() {
  return (
    <div className={styles.wrapper}>
      <h1>{strings.countdownTxt}</h1>
      <Dropdown />
      <div className={styles.buttonChip}>
        <Button text={strings.countdownBtn} />
      </div>
    </div>
  );
}
